import { SelectProps } from 'antd/lib'

import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const usePatientConfig = () => {
  const { t } = useLocales()
  const { defaultSortingOption } = useDefaultSortingItem()

  const orderingOptions: SelectProps['options'] = [
    defaultSortingOption,
    {
      value: 'testingAt',
      label: t('tests_results.testing_at_asc')
    },
    {
      value: '-testingAt',
      label: t('tests_results.testing_at_desc')
    },
    {
      value: 'status',
      label: t('tests_results.status_asc')
    },
    {
      value: '-status',
      label: t('tests_results.status_desc')
    },
    {
      value: 'type',
      label: t('tests_results.test_type_asc')
    },
    {
      value: '-type',
      label: t('tests_results.test_type_desc')
    },
    {
      value: 'resultDate',
      label: t('tests_results.test_date_asc')
    },
    {
      value: '-resultDate',
      label: t('tests_results.test_date_desc')
    }
  ]

  return { orderingOptions }
}
